import { MAIN_API_ROOT } from 'app_config';
import axios from 'axios';
import { getDeviceId } from 'helpers/tokenManager';

const axiosInstance = axios.create({
  baseURL: MAIN_API_ROOT
});

const getClientConfig = () => {
  return {
    headers: {
      deviceId: getDeviceId()
    }
  };
};

export default {
  get<T>(url: string) {
    return axiosInstance.get<T>(url, getClientConfig());
  },
  post<T>(url: string, data: any) {
    return axiosInstance.post<T>(url, data, getClientConfig());
  },
  put<T>(url: string, data: any) {
    return axiosInstance.put<T>(url, data, getClientConfig());
  },
  patch<T>(url: string, data: any) {
    return axiosInstance.patch<T>(url, data, getClientConfig());
  },
  delete(url: string) {
    return axiosInstance.delete(url, getClientConfig());
  }
};
